import React, { Component } from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import axios from "axios";
import classNames from "classnames";

import {setVehicle, toggleBoxLoading} from '../actions'
import BoxTitle from "../components/BoxTitle";
import VehicleSelectionInput from "../components/VehicleSelectionInput";
import BoxValidateButton from "../components/BoxValidateButton";
import {onElementAppear, onElementExit} from '../utils'
import {Flipped} from "react-flip-toolkit";

class VehicleSelectionBox extends Component{
    constructor(props) {
        super(props);

        this.state = {
            selectedBrandIndex : null,
            selectedModelGroupIndex : null,
            selectedModelIndex : null,
            selectedTypeIndex : null,
            brandOptions : [],
            modelGroupOptions : [],
            modelOptions : [],
            typeOptions : []
        };

        this.modelGroupSelector = React.createRef();
        this.modelSelector = React.createRef();
        this.typeSelector = React.createRef();
    }

    componentDidMount()
    {
        this.baseUrl = '/partauto/api';

        this.getBrands();
    }

    componentDidUpdate(prevProps) {
        // Typical usage (don't forget to compare props):
        if (this.props.category.id !== prevProps.category.id && !this.state.selectedTypeIndex && !this.props.vehicle.type.id) {
            this.setState({
                selectedBrandIndex: null,
                selectedModelIndex: null,
                selectedModelGroupIndex: null
            });
            this.getBrands();
        }
    }

    getCategoriesParam()
    {
        return this.props.category.id ? '?categories='+this.props.category.id : '?all=true';
    }

    toggleVehicleSelectionLoading() {
        this.props.toggleBoxLoading('vehicleSelection');
    }

    getBrands()
    {
        this.toggleVehicleSelectionLoading();
        axios(this.baseUrl+'/brands?all=true')//+this.getCategoriesParam())
            .then(function (response) {
                this.setState({brandOptions: response.data});
                this.handlePreselectVehicle(response.data, 'brand');

                const selectedIndex = response.data.findIndex(function(element) {
                    return element.id === this.props.vehicle.brand.id;
                }, this);
                if (selectedIndex > -1) {
                    this.handleBrandChange(selectedIndex);
                }
            }.bind(this))
            .catch(function (error) {
                console.log(error);
            }).finally(() => this.toggleVehicleSelectionLoading())
    }

    handleBrandChange(selectedBrandIndex) {
        this.toggleVehicleSelectionLoading();

        this.setState({
            modelGroupOptions: [],
            selectedModelGroupIndex: null,
            modelOptions: [],
            selectedModelIndex: null,
            typeOptions: [],
            selectedTypeIndex: null
        });

        const selectedBrand = this.state.brandOptions[selectedBrandIndex];

        axios(this.baseUrl+'/model_groups?all=true&brands='+selectedBrand.id)
            .then(function (response) {
                this.setState({modelGroupOptions: response.data});
                this.handlePreselectVehicle(response.data, 'modelGroup');
            }.bind(this))
            .catch(function (error) {
                console.log(error);
            }).finally(() => this.toggleVehicleSelectionLoading())
        this.setState({selectedBrandIndex: selectedBrandIndex});
    }

    handleModelGroupChange(selectedModelGroupIndex) {
        this.toggleVehicleSelectionLoading();

        this.setState({
            modelOptions: [],
            selectedModelIndex: null,
            typeOptions: [],
            selectedTypeIndex: null
        });

        const selectedModelGroup = this.state.modelGroupOptions[selectedModelGroupIndex];

        axios(this.baseUrl+'/models?all=true&model_groups='+selectedModelGroup.id)
            .then(function (response) {
                this.setState({modelOptions: response.data});
                this.handlePreselectVehicle(response.data, 'model');
            }.bind(this))
            .catch(function (error) {
                console.log(error);
            }).finally(() => this.toggleVehicleSelectionLoading())
        this.setState({selectedModelGroupIndex: selectedModelGroupIndex});
    }

    handleModelChange(selectedModelIndex) {
        this.toggleVehicleSelectionLoading();

        this.setState({
            typeOptions: [],
            selectedTypeIndex: null
        });

        const selectedModel = this.state.modelOptions[selectedModelIndex];

        axios(this.baseUrl+'/types?all=true&models='+selectedModel.id)
            .then(function (response) {
                this.setState({typeOptions: response.data});
                this.handlePreselectVehicle(response.data, 'type');
            }.bind(this))
            .catch(function (error) {
                console.log(error);
            }).finally(() => this.toggleVehicleSelectionLoading())
        this.setState({selectedModelIndex: selectedModelIndex});
    }

    handleTypeChange(selectedTypeIndex) {

        this.setState({selectedTypeIndex: selectedTypeIndex});
        this.handleValidate(selectedTypeIndex);
    }

    handlePreselectVehicle(data, vehiclePart) {
        const changeHandlerFunction = 'handle'+vehiclePart.charAt(0).toUpperCase() + vehiclePart.slice(1)+'Change';
        const selectorRef = vehiclePart+'Selector';
        const selectedIndex = data.findIndex(function(element) {
            return element.id === this.props.vehicle[vehiclePart].id;
        }, this);

        if (selectedIndex > -1) {
            this[changeHandlerFunction](selectedIndex);

            // if (!this.props.vehicle.type.id&&this.props.vehicle.modelGroup.id) {
            //     this.props.tabChangeAction();
            // }
        } else if(typeof this[selectorRef] !== 'undefined') {
            this[selectorRef].current.show();
        }
    }

    handleValidate(typeIndex) {
        const selectedTypeIndex = typeIndex !== null ? typeIndex : this.state.selectedTypeIndex;
        this.props.setVehicle(
            {
                brand : this.state.brandOptions[this.state.selectedBrandIndex],
                modelGroup : this.state.modelGroupOptions[this.state.selectedModelGroupIndex],
                model : this.state.modelOptions[this.state.selectedModelIndex],
                type: this.state.typeOptions[selectedTypeIndex]
            }
        );
    }

    render() {
        const containerClasses = classNames(
            'vehicle_selection_box',
            {
                'loading': this.props.statuses.vehicleSelection.loading,
                'completed' : this.props.completed,
                'active' : this.props.activeTab === 'vehicle_selection'
            }
        );

        return (
            <Flipped
                flipId={`vehicle_selection_box`}
                onDelayedAppear={onElementAppear}
                onExit={onElementExit}
                key={`vehicle_selection_box`}
                delay={3}
                translate
                opacity
            >
                <div className={containerClasses}>
                  <BoxTitle title="Sélectionnez votre véhicule"/>
                  <VehicleSelectionInput
                      key={"brand"}
                      title={this.state.selectedBrandIndex !== null ? this.state.brandOptions[this.state.selectedBrandIndex].name : "Choisissez votre marque"}
                      options={this.state.brandOptions}
                      changeAction={(index) => this.handleBrandChange(index)}
                      selected={this.state.selectedBrandIndex !== null}
                  />
                  <VehicleSelectionInput
                      key={"modelGroup"}
                      ref={this.modelGroupSelector}
                      title={this.state.selectedModelGroupIndex !== null ? this.state.modelGroupOptions[this.state.selectedModelGroupIndex].name : "Choisissez votre famille"}
                      options={this.state.modelGroupOptions}
                      changeAction={(index) => this.handleModelGroupChange(index)}
                      selected={this.state.selectedModelGroupIndex !== null}
                  />
                  <VehicleSelectionInput
                      key={"model"}
                      ref={this.modelSelector}
                      title={this.state.selectedModelIndex !== null ? <span>{this.state.modelOptions[this.state.selectedModelIndex].name} ({this.state.modelOptions[this.state.selectedModelIndex].start_date} - {this.state.modelOptions[this.state.selectedModelIndex].end_date}) </span>: "Choisissez votre modèle"}
                      options={this.state.modelOptions}
                      changeAction={(index) => this.handleModelChange(index)}
                      selected={this.state.selectedModelIndex !== null}
                  />
                  <VehicleSelectionInput
                      key={"type"}
                      ref={this.typeSelector}
                      title={this.state.selectedTypeIndex !== null ? this.state.typeOptions[this.state.selectedTypeIndex].name : "Choisissez votre motorisation"}
                      options={this.state.typeOptions}
                      changeAction={(index) => this.handleTypeChange(index)}
                      selected={this.state.selectedTypeIndex !== null}
                  />
                  {/*<BoxValidateButton clickAction={(e) => this.handleValidate()}/>*/}
                  {this.props.statuses.vehicleSelection.loading ? <div className="loading"></div> : null}
                </div>
            </Flipped>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        category:state.category,
        vehicle:state.vehicle,
        statuses:state.boxStatuses
    }
};

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        setVehicle,
        toggleBoxLoading
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(VehicleSelectionBox)